import type { ButtonGroupProps } from 'react-multi-carousel';

import SlideshowThumbnail from '@/app/[locale]/product/_components/Slideshow/SlideshowThumbnail';
import Image from '@/app/components/Image';

import type { ProductImage } from './types';

interface FsaSlideShowNavProps extends ButtonGroupProps {
  readonly images: ProductImage[];
  readonly onChange: (idx: number) => void;
}

interface CurrentTarget {
  currentTarget: {
    value: string;
  };
}

export const FsaSlideshowNavigation = ({
  carouselState,
  images,
  goToSlide,
  onChange,
}: FsaSlideShowNavProps): JSX.Element => {
  const currentSlideIndex = carouselState?.currentSlide;

  const handleChange = ({ currentTarget }: CurrentTarget) => {
    const nextSlideIndex = Number(currentTarget.value);
    onChange(nextSlideIndex);
    goToSlide?.(nextSlideIndex);
  };

  return (
    <div className="mx-auto my-0 mt-6 flex max-w-sm flex-1 justify-center gap-2">
      {images.map(({ alt, src }, idx: number) => (
        <SlideshowThumbnail
          data-cy={`pdp-slideshow-thumbnail-${idx}`}
          data-selected={currentSlideIndex === idx}
          key={`pdp-slideshow-thumbnail-${src}`}
          index={idx}
          isSelected={currentSlideIndex === idx}
          onClick={handleChange}
          image={
            <Image
              localizedAlt={alt}
              src={src}
              width={72}
              height={72}
              className="aspect-4/3 size-full"
            />
          }
        />
      ))}
    </div>
  );
};

export default FsaSlideshowNavigation;
